module.exports = __webpack_public_path__ + "img/masks-photo.ab2264f1.png";